//import { enguanyAnyVinent } from '../../../utils'

//const {enguany, anyVinent} = enguanyAnyVinent()

export const AuthCompromisMenors16 = ({auth, handleChange, error }) => 
{

  return (
        <div className="row">
                <div className="col col-12 ">
                <h4>
                {/* Carta de compromís educatiu: Alumnat menors 16 anys complerts. Curs {props.enguany}-{props.anyVinent} */}
                Carta de compromís educatiu
                </h4>

                        <p>La carta de compromís educatiu és un document que té com a finalitat potenciar la comunicació, la participació, la implicació, el compromís i la 
                        coresponsabilitat entre els centres i les famílies en l'educació d'infants i joves.  Aquesta carta té per objectius principals, entre d'altres:</p>

                        <ol>
                        <li>Compartir amb les famílies els principis i els continguts del projecte educatiu del centre i, si escau, els projectes educatius de l'entorn.</li>
                        <li>Millorar la informació i la comunicació entre el centre i les famílies.</li>
                        <li>Facilitar a les famílies l'exercici dels seus drets i el compliment dels deures.</li>
                        <li>Fomentar la convivència i el bon clima escolar.</li>
                        <li>Coresponsabilitzar el centre i la família en l'èxit acadèmic, personal i social dels alumnes i també en el compromís cívic dels infants i joves.</li>
                        </ol>

                        <p>El centre, les famílies i l'alumnat signem aquest document i ens comprometem amb les mesures i recomanacions aquí subscrites per millorar 
                        així el clima escolar, la comunicació i els resultats acadèmics de l'alumnat.</p>

                <h5>
                Per part del centre:
                </h5>

                <ol>
                <li>Facilitar una bona relació amb l'alumnat establint canals de comunicació per facilitar el seguiment de la progressió acadèmica, professional i personal de l'alumnat. S'informa tres cops al curs de l'avaluació i evolució de l'alumnat.</li>
                <li>Instar a l'alumnat a respectar les normes de funcionament de l'escola, en particular, les que afecten la convivència escolar, el desenvolupament normal de les classes i les activitats complementàries.</li>
                <li>Informar la família dels resultats de les avaluacions i de l'evolució acadèmica i personal de l'alumnat.</li>
                <li>Oferir uns continguts i una metodologia d'ensenyament que procuri estimular el progrés de l'alumne/a vers l'obtenció dels millors resultats acadèmics i l'adquisició de destreses i habilitats per aconseguir l'excel·lència en el nostre ofici, d'acord amb les seves capacitats, mitjançant el treball personalitzat i l'avaluació continuada.</li>
                <li>Facilitar unes pràctiques de qualitat a l'alumne/a per tal d'aconseguir completar de manera correcta la seva formació en l'ofici escollit, arribar a ser un professional d'èxit i aportar valor afegit al sector.</li>
                <li>Informar a la família del projecte educatiu de centre (PEC) i de les normés d'organtizació i funcionament del centre (NOFC) incloent-hi els acords de centre sobre l'ús dels telèfons mòbils.</li>
                </ol>


                <h5>
                Per part de la família:
                </h5>

                        <ol>
                        <li>Contribuir a crear un vincle de confiança mútua amb els professionals de l'escola per a treballar conjuntament en la construcció del futur del nostre fill o filla.</li>
                        <li>Instar el fill o la filla a respectar les normes de funcionament de l'escola, en particular, les que afecten la normativa del cicle formatiu, uniformitat, sanitat,...</li>
                        <li>Atendre les peticions d'entrevistes i/o de comunicacions que formuli l'escola.</li>
                        <li>Compartir amb l'escola tota la informació que sigui rellevant pel procés d'aprenentatge i progrés personal del nostre fill o filla.</li>
                        <li>Col·laborar amb l'escola en el procés de millora contínua, amb suggeriments i reflexions de tot allò que pugui ser susceptible de ser millorat, a través dels canals establerts (entrevistes, web, correu electrònic...)</li>
                        <li>Respectar les normes d'organització i funcionament del centre (NOFC) i la regulació dels telèfons mòbils que s'hi específica.</li>
                        </ol>

                <h5>
                Per part de l'alumne:
                </h5>

                        <ol>
                        <li>Assistir a classe, participar en les activitats formatives previstes a la programació general del centre i respectar els horaris establerts.</li>
                        <li>Respectar les Normes bàsiques de convivència, en particular aquelles que afecten el desenvolupament normal de les classes i activitats professionalitzadores prestant especial esment a: atenció, esforç, col·laboració, educació, higiene personal, uniformitat, respecte a les persones i als mitjans disponibles, limitació de l'ús de telèfons mòbils i xarxes socials durant la jornada escolar.</li>
                        <li>Realitzar les tasques encomanades pel professorat en l'exercici de les seves funcions docents.</li>
                        </ol>

                <p>
                <input type="checkbox" id="authCompromis" name="authCompromis" value={auth} checked={auth === "1" ? true : false } onChange={ (t) => { handleChange(t.target.value) } } required/>
                <label htmlFor="authCompromis">Perquè així consti, signem aquesta carta de compromís educatiu.</label>
                <span id="auhtMaterial_ERROR" className="a-Form-error">{error}</span>
                </p>

                </div>
        </div>

        )
}

export const AuthCompromis = ({auth, handleChange, error }) => 
{

  return (
        <div className="row">
                <div className="col col-12 ">

                <h4>
{/*                                    Carta de compromís educatiu: Alumnat menors 16 anys complerts. Curs {props.enguany}-{props.anyVinent} */}
                Carta de compromís educatiu
                </h4>

                        <p>La carta de compromís educatiu és un document que té com a finalitat potenciar la comunicació, la participació, la implicació, el compromís i la 
                        coresponsabilitat entre els centres i les famílies en l'educació d'infants i joves.  Aquesta carta té per objectius principals, entre d'altres:</p>

                        <ol>
                        <li>Compartir amb les famílies els principis i els continguts del projecte educatiu del centre i, si escau, els projectes educatius de l'entorn.</li>
                        <li>Millorar la informació i la comunicació entre el centre i les famílies.</li>
                        <li>Facilitar a les famílies l'exercici dels seus drets i el compliment dels deures.</li>
                        <li>Fomentar la convivència i el bon clima escolar.</li>
                        <li>Coresponsabilitzar el centre i la família en l'èxit acadèmic, personal i social dels alumnes i també en el compromís cívic dels infants i joves.</li>
                        </ol>

                        <p>El centre, les famílies i l'alumnat signem aquest document i ens comprometem amb les mesures i recomanacions aquí subscrites per millorar 
                        així el clima escolar, la comunicació i els resultats acadèmics de l'alumnat.</p>

                <h5>
                Per part del centre:
                </h5>

                <ol>
                <li>Facilitar una bona relació amb l'alumnat establint canals de comunicació per facilitar el seguiment de la progressió acadèmica, professional i personal de l'alumnat. S'informa tres cops al curs de l'avaluació i evolució de l'alumnat.</li>
                <li>Instar a l'alumnat a respectar les normes de funcionament de l'escola, en particular, les que afecten la convivència escolar, el desenvolupament normal de les classes i les activitats complementàries.</li>
                <li>Informar la família dels resultats de les avaluacions i de l'evolució acadèmica i personal de l'alumnat.</li>
                <li>Oferir uns continguts i una metodologia d'ensenyament que procuri estimular el progrés de l'alumne/a vers l'obtenció dels millors resultats acadèmics i l'adquisició de destreses i habilitats per aconseguir l'excel·lència en el nostre ofici, d'acord amb les seves capacitats, mitjançant el treball personalitzat i l'avaluació continuada.</li>
                <li>Facilitar unes pràctiques de qualitat a l'alumne/a per tal d'aconseguir completar de manera correcta la seva formació en l'ofici escollit, arribar a ser un professional d'èxit i aportar valor afegit al sector.</li>
                </ol>


                <h5>
                Per part de la família:
                </h5>

                        <ol>
                        <li>Contribuir a crear un vincle de confiança mútua amb els professionals de l'escola per a treballar conjuntament en la construcció del futur del nostre fill o filla.</li>
                        <li>Instar el fill o la filla a respectar les normes de funcionament de l'escola, en particular, les que afecten la normativa del cicle formatiu, uniformitat, sanitat,...</li>
                        <li>Atendre les peticions d'entrevistes i/o de comunicacions que formuli l'escola.</li>
                        <li>Compartir amb l'escola tota la informació que sigui rellevant pel procés d'aprenentatge i progrés personal del nostre fill o filla.</li>
                        <li>Col·laborar amb l'escola en el procés de millora contínua, amb suggeriments i reflexions de tot allò que pugui ser susceptible de ser millorat, a través dels canals establerts (entrevistes, web, correu electrònic...)</li>
                        </ol>

                <h5>
                Per part de l'alumne:
                </h5>

                        <ol>
                        <li>Assistir a classe, participar en les activitats formatives previstes a la programació general del centre i respectar els horaris establerts.</li>
                        <li>Respectar les Normes bàsiques de convivència, en particular aquelles que afecten el desenvolupament normal de les classes i activitats professionalitzadores prestant especial esment a: atenció, esforç, col·laboració, educació, higiene personal, uniformitat, respecte a les persones i als mitjans disponibles, limitació de l'ús de telèfons mòbils i xarxes socials durant la jornada escolar.</li>
                        <li>Quan l'alumnat desenvolupi el rol de client, s'ha de comportar amb respecte i educació amb els companys que fan les pràctiques, respectant horaris i temps del servei. També ha de mostrar una bona predisposició a tastar i menjar nous plats i productes que no li són afins, per tal de completar la seva formació.</li>
                        <li>Realitzar les tasques encomanades pel professorat en l'exercici de les seves funcions docents.</li>
                        </ol>

                <p>
                <input type="checkbox" id="authCompromis" name="authCompromis" value={auth} checked={auth === "1" ? true : false } onChange={ (t) => { handleChange(t.target.value) } } required/>
                <label htmlFor="authCompromis">Perquè així consti, signem aquesta carta de compromís educatiu.</label>
                <span id="auhtMaterial_ERROR" className="a-Form-error">{error}</span>
                </p>


                </div>
        </div>

        )
}